import { Theme } from "@mui/material/styles";

/* eslint-disable quote-props */
export const cardStyle = () => ({
  textAlign: "center",
  borderRadius: "8px",
  boxShadow: "none",
  width: "99%",
  margin: "0.5%",
  height: "100%",
  border: "1px solid #E8DFD7",
  "&:hover": {
    transform: "scale(1.01)",
    border: "1px solid #E5AF0A",
  },
});

export const cardStyleActive = (theme: Theme) => ({
  textAlign: "center",
  borderRadius: "8px",
  boxShadow: "none",
  width: "100%",
  height: "100%",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
});

export const cardInnerStyle = () => ({
  padding: ".5rem 1.35rem 1.35rem",
  background: "transparent",
  boxShadow: "none",
});

export const boxIconContainer = (theme: Theme) => ({
  display: "inline-block",
});

export const iconStyle = (theme: Theme) => ({
  width: "80px",
  height: "80px",
  margin: "1rem",
  borderRadius: "50%",
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
  "& svg": {
    fontSize: 32,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const compactCardStyle = () => ({
  "textAlign": "center" as const,
  "borderRadius": "8px",
  "boxShadow": "none",
  "width": "100%",
  "border": "1px solid",
  "borderColor": "taupe.dark",
  "backgroundColor": "white.main",
  "cursor": "pointer",
  "transition": "border-color 0.2s ease",
  "&:hover": {
    borderColor: "primary.dark",
  },
});

export const compactCardStyleActive = (theme: Theme) => ({
  textAlign: "center" as const,
  borderRadius: "8px",
  boxShadow: "none",
  width: "100%",
  border: "1px solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
  cursor: "pointer",
});
